import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import AppShell from "../components/AppShell";
import PageHero from "../components/PageHero";
import SidebarToggleButton from "../components/SidebarToggleButton";
import { AiStudioPreview } from "../components/ProjectPreviewModal";
import { api } from "../lib/api";
import { ArrowLeft, FlaskConical, Loader2 } from "lucide-react";

// Dedicated /projects/formulations/:id page for a saved formulation.
export default function FormulationProjectView() {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    setError(false);
    api.get(`/projects/${id}`)
      .then((r) => setItem(r.data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [id]);

  const isFormulation = item?.type === "ai_studio" && item?.ai_studio_tool === "formulation";
  const created = item?.created_at ? new Date(item.created_at).toLocaleString() : "";

  return (
    <AppShell title={item?.name || "Saved formulation"}>
      <div className="w-full min-w-0" data-testid="formulation-project-page">
        <Link
          to="/projects"
          className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
          data-testid="formulation-project-back"
        >
          <ArrowLeft className="w-3.5 h-3.5" /> Back to Projects
        </Link>

        <PageHero
          eyebrow="Saved formulation"
          icon={FlaskConical}
          title={<span className="break-words [overflow-wrap:anywhere]">{item?.name || "Saved formulation"}</span>}
          subtitle={loading ? "Loading formulation…" : created ? `Created ${created}` : ""}
          right={<SidebarToggleButton testId="formulation-project-sidebar-toggle" />}
          className="mt-2"
          testid="formulation-project-hero"
        />

        <div className="mt-6 card-elevated p-4 sm:p-6 min-w-0" data-testid="formulation-project-body">
          {loading ? (
            <div className="py-16 text-center text-sm text-muted-foreground inline-flex items-center gap-2 justify-center w-full">
              <Loader2 className="w-4 h-4 animate-spin" /> Loading formulation…
            </div>
          ) : error || !isFormulation ? (
            <div className="py-12 text-center text-sm text-muted-foreground" data-testid="formulation-project-missing">
              This saved formulation is unavailable — it may have been deleted.
            </div>
          ) : (
            <AiStudioPreview item={item} onClose={() => {}} showStudioLink={false} />
          )}
        </div>
      </div>
    </AppShell>
  );
}
